import { ThemeProvider, createTheme, responsiveFontSizes  } from '@mui/material/styles';


export const th = {
  palette: {
    type: 'dark',
    primary: {
      main: '#005193',
      light: '#caf8ff',
      contrastText: '#fff',
    },
    secondary: {
      main: '#16bf5a',
      contrastText: '#ffffff',
    },
    text: {
      primary: '#ffffff',
      disabled: 'rgba(164,164,204,0.5)',
      secondary: '#caf8ff',
      dark: '#005193',
      hint: 'rgba(200,207,241,0.86)',
    },
    background: {
      default: '#005193',
      paper: '#006AAB',
      dark: '#0770e0',
      translucid: 'rgba(0 ,106, 171, 0.5)',
      transparent: 'rgba(0 ,106, 171, 0.1)',
      white: '#ffffff',
    },
    divider: '#006AAB',
    error: {
      main: '#de5026',
    },
  },
  typography: {
    fontFamily: 'CiudadelaMedium',
    fontSize: 15,
    body1: {
      fontFamily: 'CiudadelaMedium',
      fontSize: 20,
      fontWeight: 'Regular',
      paddingBottom: 15,
      paddingTop: 8,
    },
    body2: {
      fontFamily: 'CiudadelaMedium',
      fontSize: 13,
      fontWeight: 'Medium',
      paddingBottom: 15,
      paddingTop: 8,
    },
    stack: {
      fontFamily: 'CiudadelaMedium',
      fontSize: '.8rem',
      textTransform: 'uppercase',
      fontWeight: 700,
    },
    h1: {
      fontFamily: 'BlancoBold',
      fontSize: 30,
      fontWeight: 600,
      paddingBottom: 40,
    },
    h2: {
      fontFamily: 'BlancoBold',
      fontWeight: 600,
      fontSize: 28,
    },
    h3: {
      fontFamily: 'BlancoBold',
      fontWeight: 700,
      fontSize: 26,
    },
    h4: {
      fontFamily: 'CiudadelaBold',
      fontWeight: 700,
      fontSize: 24,
    },
    h5: {
      fontWeight: 300,
      fontFamily: 'BlancoBold',
      fontSize:  22,
    },
    h6: {
      fontWeight: 1000,
      fontSize: 20,
    },
    subtitle1: {
      fontFamily: 'CiudadelaRegular',
      fontWeight: 400,
      fontSize: '1.1rem',
    },
    subtitle2: {
      fontFamily: 'CiudadelaBoldItalic',
      fontWeight: 400,
      fontSize: '.9rem',
    },
    button: {
      fontSize: 12,
      fontFamily: 'BlancoBold',
      fontWeight: 700,
    }
  },
  shape: {
    borderRadius: 2,
  },
};


let theme = createTheme(th);
theme = responsiveFontSizes(theme);

const Theme = ({children}) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>

}
export default Theme;
